module.exports = {
	'customFolder.m4.m410130_grid': {
		'courseName': 'Course title',
		'courseClassification': 'Category',
		'modeOfDelivery': 'Method',
		'typeOfTraining': 'Type',
		'classTime': 'Course time',
		'courseHours': 'Course hours',
		'learningStatus': 'Learning status',
	},
	'customFolder.m4.m410130': {
		'manifestMode': 'List Mode',
		'chartMode': 'Graphic Mode',
	},
	'customFolder.m4.m410130_chart': {
		'anOverviewOfLearningRecords': 'Overview',
		'hours': 'Hour',
		'hall': 'Course',
		'totalPeople': 'Total <%=temp1%> employee<%=s%>.',
		'noData': 'No data',
	},
	'customFolder.m4.m410130_browse': {
		'courseRequirements': 'Course source',
		'organizers': 'Organizing committee',
		'instructorSName': 'Lecture',
		'trainingLocation': 'Location',
		'credit': 'Credit',
		'quizScores': 'Test score',
		'quizResults': 'Test status',
		'reasonForNonConformity': 'Reason for disqualification',
		'costSharingCorporate': 'Cost sharing (company)',
		'costSharingEmployees': 'Cost sharing (employee)',
		'theDurationOfTheContractFor': 'Employment contract duration',
		'theExpirationDateOfTheJob': 'Employment contract expiration date',
		'tempYears': '<%=temp1%> year<%=s%>',
		'tempMonth': ' <%=temp1%> month<%=s%>',
		'tempYearsAndMonths': '<%=temp1%> year<%=s1%> and <%=temp2%> month<%=s2%>',
		'hour': 'hour',
		'credits': 'credit',
		'divide': ' ',
	},
	'customFolder.service.m3.service-m310240': {
		'aBreakdownOfTheDepartmentS': 'Subordinates Learning Records',
	},
};
